import * as yup from "yup";

const ManageCompSchema = yup.object().shape({
  name: yup.string().required("Please enter the value"),
});

export default ManageCompSchema;
